class StringService {
  static reverse = (givenEntry) => givenEntry.toString().split("").reverse().join("");

  static reverseReplace = (givenEntry, searchValue, replaceValue) =>
    StringService.reverse(StringService.reverse(givenEntry).replace(searchValue, replaceValue));
}

export default StringService;
